

var ConstantsDzsvg = require('../configs/Constants').constants;

function version_firefox() {
  if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
    var aversion = Number(RegExp.$1);
    return (aversion);
  }
  ;
}
;

if(!window.multisharer_markup){
  /** default is window.multisharer_markup='<div class="dzsvg-main-con skin-default gallery-skin-default transition-slideup "> <div class="overlay-background"></div> <div class="box-mains-con"> <div class="box-main" style=""> <div class="box-main-media-con transition-target"> <div class="close-btn-con"> <svg enable-background="new 0 0 40 40" id="" version="1.1" viewBox="0 0 40 40" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M28.1,26.8c0.4,0.4,0.4,1,0,1.4c-0.2,0.2-0.5,0.3-0.7,0.3s-0.5-0.1-0.7-0.3l-6.8-6.8l-6.8,6.8c-0.2,0.2-0.5,0.3-0.7,0.3 s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l6.8-6.8l-6.8-6.8c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l6.8,6.8l6.8-6.8 c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4L21.3,20L28.1,26.8z"></path></g><g><path d="M19.9,40c-11,0-20-9-20-20s9-20,20-20c4.5,0,8.7,1.5,12.3,4.2c0.4,0.3,0.5,1,0.2,1.4c-0.3,0.4-1,0.5-1.4,0.2 c-3.2-2.5-7-3.8-11-3.8c-9.9,0-18,8.1-18,18s8.1,18,18,18s18-8.1,18-18c0-3.2-0.9-6.4-2.5-9.2c-0.3-0.5-0.1-1.1,0.3-1.4 c0.5-0.3,1.1-0.1,1.4,0.3c1.8,3.1,2.8,6.6,2.8,10.2C39.9,31,30.9,40,19.9,40z"></path></g></svg></div> <div class="box-main-media type-inlinecontent" style="width: 530px; height: 280px;"><div class=" real-media" style=""><div class="hidden-content share-content" > <div class="social-networks-con"></div> <div class="share-link-con"></div> <div class="embed-link-con embed-link-con-for-dzsvg"></div> </div> </div> </div> <div class="box-main-under"></div> </div> </div> </div><!-- end .box-mains-con--> </div>' */
  window.multisharer_markup = 'include multisharer content';
}

function get_query_arg(purl, key) {
  if (purl.indexOf(key + '=') > -1) {
    //faconsole.log('testtt');
    var regexS = "[?&]" + key + "=.+";
    var regex = new RegExp(regexS);
    var regtest = regex.exec(purl);
    //console.info(regtest);

    if (regtest != null) {
      var splitterS = regtest[0];
      if (splitterS.indexOf('&') > -1) {
        var aux = splitterS.split('&');
        splitterS = aux[1];
      }
      //console.log(splitterS);
      var splitter = splitterS.split('=');
      //console.log(splitter[1]);
      //var tempNr = ;

      return splitter[1];

    }
    //$('.zoombox').eq
  }
}

function can_translate() {
  if (is_chrome() || is_safari()) {
    return true;
  }
  if (is_firefox() && version_firefox() > 10) {
    return true;
  }
  return false;
}


function is_safari() {
  return navigator.userAgent.toLowerCase().indexOf('safari') > -1;
}
;

exports.player_setQualityLevels = function (selfClass) {

  var $temp_qualitiesFromFeed = selfClass.cthis.find('.dzsvg-feed-quality');
  if ($temp_qualitiesFromFeed.length) {
    selfClass.cthis.addClass('has-multiple-quality-levels');


    var $qualitySelector = selfClass.cthis.find('.quality-selector');
    var str_qualitiesTooltip = $qualitySelector.find('.dzsvg-tooltip').html();

    var aux_opts = '';

    var added = false;


    var curr_qual_added = false;
    $temp_qualitiesFromFeed.each(function () {
      var _t2 = $(this);


      aux_opts += '<div class="quality-option';


      // -- quality option has data-source ( _t2 )
      if (_t2.attr('data-source') === selfClass.dataSrc) {
        aux_opts += ' active';
        added = true;
      }


      aux_opts += '" data-val="' + _t2.attr('data-label') + '" data-source="' + selfClass.dataSrc + '">' + _t2.attr('data-label') + '</div>';
    })

    if (added === false) {

      aux_opts += '<div class="quality-option active ';


      aux_opts += '" data-val="' + selfClass.initOptions.settings_currQuality + '" data-source="' + selfClass.dataSrc + '">' + selfClass.initOptions.settings_currQuality + '</div>';

    }


    // console.log({str_qualitiesTooltip});
    if (str_qualitiesTooltip) {

      // aux = aux.replace('{{svg_quality_icon}}',helpersSvg.svg_quality_icon);
      str_qualitiesTooltip = str_qualitiesTooltip.replace('{{quality-options}}', aux_opts);
      $qualitySelector.find('.dzsvg-tooltip').html(str_qualitiesTooltip);
    } else {
      console.warn('no aux ? ', str_qualitiesTooltip, $qualitySelector);
    }


  }
}


function is_android() {


  var ua = navigator.userAgent.toLowerCase();
  return (ua.indexOf("android") > -1);
}

function is_touch_device() {
  //return true;
  return !!('ontouchstart' in window);
}

function can_history_api() {
  return !!(window.history && history.pushState);
}

function add_query_arg(purl, key, value) {
  key = encodeURIComponent(key);
  value = encodeURIComponent(value);

  var s = purl;
  var pair = key + "=" + value;

  var r = new RegExp("(&|\\?)" + key + "=[^\&]*");

  s = s.replace(r, "$1" + pair);
  //console.log(s, pair);
  if (s.indexOf(key + '=') > -1) {


  } else {
    if (s.indexOf('?') > -1) {
      s += '&' + pair;
    } else {
      s += '?' + pair;
    }
  }
  //if(!RegExp.$1) {s += (s.length>0 ? '&' : '?') + kvp;};


  //if value NaN we remove this field from the url
  if (value === 'NaN') {
    var regex_attr = new RegExp('[\?|\&]' + key + '=' + value);
    s = s.replace(regex_attr, '');
  }

  return s;
}


function is_ios() {
  // return true;
  return ((navigator.platform.indexOf("iPhone") != -1) || (navigator.platform.indexOf("iPod") != -1) || (navigator.platform.indexOf("iPad") != -1 || (navigator.platform.indexOf("MacIntel") != -1 && is_touch_device()))
  );
}

function fullscreen_status() {
  if (document.fullscreenElement !== null && typeof document.fullscreenElement !== "undefined") {
    return 1;
  } else if (document.webkitFullscreenElement && typeof document.webkitFullscreenElement !== "undefined") {
    return 1;
  } else if (document.mozFullScreenElement && typeof document.mozFullScreenElement !== "undefined") {
    return 1;
  } else return 0;
}


function is_chrome() {
  return navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
}
;
const helpersSvg = require('./_dzsvg_svgs');
exports.player_controls_generatePlayCon = function (o) {

  var structPlayControls = '';
  structPlayControls = '<div class="playSimple dzsvgColorForFills">';
  if (o.design_skin == 'skin_bigplay_pro') {

    structPlayControls += helpersSvg.svg_play_simple_skin_bigplay_pro;
  }
  if (o.design_skin == 'skin_aurora' || o.design_skin == 'skin_bigplay' || o.design_skin == 'skin_avanti' || o.design_skin == 'skin_default' || o.design_skin == 'skin_pro' || o.design_skin == 'skin_white') {
    structPlayControls += helpersSvg.svg_aurora_play_btn;
  }


  structPlayControls += '</div><div class="pauseSimple dzsvgColorForFills">';
  if (o.design_skin == 'skin_aurora' || o.design_skin == 'skin_pro' || o.design_skin == 'skin_bigplay' || o.design_skin == 'skin_avanti' || o.design_skin == 'skin_default' || o.design_skin == 'skin_white') {

    structPlayControls += helpersSvg.svg_pause_simple_skin_aurora;
  }
  structPlayControls += '</div>';


  structPlayControls += '<div class="dzsvg-player--replay-btn dzsvgColorForFills">';
  structPlayControls += helpersSvg.svgReplayIcon;

  structPlayControls += '</div>';


  return structPlayControls;
}
exports.dzsvg_call_video_when_ready = function (o, _videoElement, init_readyVideo, vimeo_is_ready, inter_videoReadyState) {


  // console.log('check_videoReadyState', video, '_videoElement.readyState - ', _videoElement.readyState, 'o.type - ', o.type);


  if (o.type === 'youtube' && _videoElement.getPlayerState) {

    init_readyVideo();
  }

  // console.info('_videoElement.readyState - ',   _videoElement.readyState);


  if (is_firefox() && o.cueVideo != 'on' && (o.type == 'selfHosted' || o.type == 'audio') && Number(_videoElement.readyState) >= 2) {
    init_readyVideo({
      'called_from': 'check_videoReadyState'
    });
    return false;
  }


  if (o.type == 'vimeo' && o.vimeo_is_chromeless == 'on') {

    if (vimeo_is_ready) {
      init_readyVideo();
      return false;
    }
  }
  if (o.type == 'audio') {
    if (is_mobile()) {
      if (Number(_videoElement.readyState) >= 1) {

        init_readyVideo();
        return false;
      }
    }


    if (Number(_videoElement.readyState) >= 3) {
      clearInterval(inter_videoReadyState);
      init_readyVideo({
        'called_from': 'check_videoReadyState'
      });
      return false;
    }
  }
  if (o.type === 'selfHosted') {

    // console.log('navigator.platform - ', navigator.platform);
    if (is_ios()) {
      // console.log('ios - readyState - ', Number(_videoElement.readyState));
      if (Number(_videoElement.readyState) >= 1) {

        init_readyVideo();
        return false;
      }
    }

    if (is_android()) {
      if (Number(_videoElement.readyState) >= 2) {

        init_readyVideo();
        return false;
      }
    }


    if (Number(_videoElement.readyState) >= 3 || o.preload_method == 'none') {
      clearInterval(inter_videoReadyState);
      init_readyVideo({
        'called_from': 'check_videoReadyState'
      });
      return false;
    }
  }


  // --- WORKAROUND __ for some reason ios default browser would not go over video ready state 1

  if (o.type == 'dash') {
    //console.warn(_videoElement.readyState)
    clearInterval(inter_videoReadyState)
    init_readyVideo({
      'called_from': 'check_videoReadyState'
    });
  }


}

function dzsvg_click_open_embed_ultibox() {
  // -- this is used for video gallery
  // -- @triggered on clicking multisharer button in dzsvg


  // console.info('ceva');

  var _c = jQuery('.dzsvg-main-con').eq(0);

  // console.info('_c -> ',_c, cgallery.find('.feed-dzsvg--for-social-networks').eq(0).html(), _c.find('.social-networks-con'));


  var _t = jQuery(this);
  var _vg = null
    , _vp = null
  ;

  console.log('_t -dzsvg_click_open_embed_ultibox()- ', _t, _t.parent().parent().parent());


  var _par_par_par = _t.parent().parent().parent();
  // -- if this is a button in video player ?
  if (_par_par_par.hasClass('vplayer')) {
    _vp = _par_par_par;
  }
  // -- if this is a button in video gallery ?
  if (_par_par_par.hasClass('videogallery')) {
    _vg = _par_par_par;
  }

  var aux = '';

  if (window.dzsvg_social_feed_for_social_networks) {
    aux = window.dzsvg_social_feed_for_social_networks;
  }


  aux = aux.replace(/&quot;/g, '\'');
  aux = aux.replace('onclick=""', '');

  _c.find('.social-networks-con').html(aux);


  aux = '';


  if (window.dzsvg_social_feed_for_share_link) {
    aux = window.dzsvg_social_feed_for_share_link;
  }


  if (aux) {

    aux = aux.replace('{{replacewithcurrurl}}', window.location.href);
    _c.find('.share-link-con').html(aux);
  }

  aux = '';
  if (window.dzsvg_social_feed_for_embed_link) {
    aux = window.dzsvg_social_feed_for_embed_link;
  }


  // console.info('%c embed', 'background-color: #eee;', 'dzsvg_social_feed_for_embed_link - ',aux);
  // console.info('_vp - ',_vp, '_vg - ',  _vg);

  // -- for single video player
  if ((_vp || _vg) && aux) {

    if (_vp && _vp.data('embed_code')) {
      jQuery('.embed-link-con').show();
      aux = aux.replace('{{replacewithembedcode}}', htmlEntities(_vp.data('embed_code')));

      // console.info('_c.find(\'.embed-link-con\') - ',_c.find('.embed-link-con'));
      _c.find('.embed-link-con').html(aux);
    } else {


      if (_vg && aux) {

        var iframe_code = '<div style="width: 100%; padding-top: 67.5%; position: relative;"><iframe src=\'' + dzsvg_settings.dzsvg_site_url + '?action=embed_dzsvg&type=' + 'gallery' + '&id=' + _vg.attr('data-dzsvg-gallery-id') + '\'  width="100%" style="position:absolute; top:0; left:0; width: 100%; height: 100%;" scrolling="no" frameborder="0" allowfullscreen allow></iframe>';

        var encodedStr = String(iframe_code).replace(/[\u00A0-\u9999<>\&]/gim, function (i) {
          return '&#' + i.charCodeAt(0) + ';';
        });
        aux = aux.replace('{{replacewithembedcode}}', encodedStr);

        // -- inspired from php @generate_embed_code
        _c.find('.embed-link-con').html(aux);
      } else {

        // -- hide embed link if we do not have embed_code
        jQuery('.embed-link-con').hide();
      }
    }
  }


  jQuery(document).on('click.dzsvg', '.field-for-view', function () {

    // console.info("HMM ", this);
    // selectText(this);

    jQuery(this).select();
  });
  setTimeout(function () {

    _c.addClass('loading-item');
  }, 100);

  setTimeout(function () {
    _c.addClass('loaded-item');
  }, 200);
}


function get_base_url_arr() {
  var scripts = document.getElementsByTagName("script");
  var scriptKey = '';
  for (scriptKey in scripts) {
    if (scripts[scriptKey] && scripts[scriptKey].src && String(scripts[scriptKey].src).indexOf('vplayer.js') > -1) {
      break;
    }
  }
  var baseUrl_arr = String(scripts[scriptKey].src).split('/');
  return baseUrl_arr;
}


function dzsvg_check_multisharer() {
  // console.info("LOAD MULTISHARER");


  setTimeout(function () {


    jQuery('body').append(multisharer_markup);


  }, 1000);


  jQuery(document).on('click.dzsvg', '.dzsvg-main-con .close-btn-con,.dzsvg-main-con .overlay-background', function () {

    var _c = jQuery('.dzsvg-main-con').eq(0);

    _c.removeClass('loading-item loaded-item');
  })

  jQuery(document).on('click.dzsvg', '.dzsvg-multisharer-but', dzsvg_click_open_embed_ultibox);
  jQuery(document).on('click.dzsvg', '.dzsvg-main-con .close-btn-con,.dzsvg-main-con .overlay-background', function () {

    var _c = jQuery('.dzsvg-main-con').eq(0);

    _c.removeClass('loading-item loaded-item');
  })


}


function is_mobile() {
  // return true;
  return is_ios() || is_android();
}

function is_firefox() {
  if (navigator.userAgent.indexOf("Firefox") != -1) {
    return true;
  }
  ;
  return false;
}
;

exports.detect_startItemBasedOnQueryAddress = function (deeplinkGotoItemQueryParam = '', cid = '') {

  if (this.get_query_arg(window.location.href, deeplinkGotoItemQueryParam) && jQuery('.videogallery').length == 1) {
    return Number(this.get_query_arg(window.location.href, deeplinkGotoItemQueryParam)) - 1;
  }
  if (this.get_query_arg(window.location.href, deeplinkGotoItemQueryParam + '-' + cid)) {
    return Number(this.get_query_arg(window.location.href, deeplinkGotoItemQueryParam + '-' + cid)) - 1;

  }

  return null;
}
exports.sanitize_to_youtube_id = function (arg = '') {
  var fourArr = null;

  if (arg) {
    arg = this.detect_video_type_and_source(arg).source;
  }
  return arg;
}
exports.getDataOrAttr = getDataOrAttr;

/**
 *
 * @param _c the video player element
 * @param attr attribute
 * @returns {null|jQuery|undefined|*}
 */
function getDataOrAttr(_c, attr) {
  if (_c.data && typeof _c.data(attr) != 'undefined') {
    return _c.data(attr);
  }
  if (_c.attr && typeof _c.attr(attr) != 'undefined') {
    return _c.attr(attr);
  }

  return null;
}

exports.detect_videoTypeAndSourceForElement = function (_el) {

  if (_el.data('originalPlayerAttributes')) {
    return _el.data('originalPlayerAttributes');
  }

  var dataSrc = this.getDataOrAttr(_el, 'data-sourcevp');

  var forceType = this.getDataOrAttr(_el, 'data-type') ? this.getDataOrAttr(_el, 'data-type') : '';

  return this.detect_video_type_and_source(dataSrc, forceType)
}
/**
 * detect video type and source
 * @param dataSrc
 * @param forceType we might want to force the type if we know it
 * @returns {{source: *, playFrom: null, type: string}}
 */
exports.detect_video_type_and_source = function (dataSrc, forceType = null, cthis = null) {

  // console.log('dataSrc -> ', dataSrc, String(dataSrc).indexOf('youtube.com/watch?') > -1 || String(dataSrc).indexOf('youtube.com/embed') > -1 || String(dataSrc).indexOf('https://youtu.be/') > -1 || String(dataSrc).indexOf('https://youtu.be/') > -1);

  var playFrom = null;
  var type = 'selfHosted';
  var source = dataSrc;
  if (String(dataSrc).indexOf('youtube.com/watch?') > -1 || String(dataSrc).indexOf('youtube.com/embed') > -1 || String(dataSrc).indexOf('youtu.be/') > -1) {
    type = 'youtube';

    var aux = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/g.exec(dataSrc);
    // console.log('aux -7 ', aux);

    if (get_query_arg(dataSrc, 't')) {
      playFrom = get_query_arg(dataSrc, 't');
    }
    if (aux && aux[1]) {
      source = aux[1];
    } else {
      // -- let us try youtube embed
      source = dataSrc.replace(/http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/|be\.com)\/embed\//g, '');
    }
  }

  if (String(dataSrc).indexOf('vimeo.com/') > -1) {
    type = 'vimeo';

    var aux = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/g.exec(dataSrc);


    if (aux && aux[1]) {
      source = aux[1];
    }
  }

  if (String(dataSrc).indexOf('.mp4') > -1) {
    type = 'selfHosted';

  }
  if (String(dataSrc) && String(dataSrc).indexOf('.mpd') > String(dataSrc).length - 5) {
    type = 'dash';
  }
  if (forceType && forceType !== 'detect') {
    type = forceType;
  }

  // console.log('playFrom -' , playFrom);
  if (!playFrom) {
    // console.log(cthis.attr('data-play_from'));
    if (cthis && cthis.attr('data-play_from')) {
      playFrom = cthis.attr('data-play_from');
    }
  }
  return {
    type,
    source,
    playFrom
  };
}

exports.sanitizeDataAdArrayStringToArray = function (aux) {

  var ad_array = null;
  try {
    // temp - try to remove slashes manually
    aux = aux.replace(/{\\"/g, '{"');
    aux = aux.replace(/\\":/g, '":');
    aux = aux.replace(/:\\"/g, ':"');
    aux = aux.replace(/\\",/g, '",');
    aux = aux.replace(/\\"}/g, '"}');
    aux = aux.replace(/,\\"/g, ',"');
    ad_array = JSON.parse(aux);
  } catch (err) {
    console.log('ad array parse error', aux);
  }

  return ad_array;


}

exports.is_autoplay_and_muted = function (autoplay, o) {

  return ((1) && autoplay == 'on' && o.autoplayWithVideoMuted == 'on' && o.user_action == 'noUserActionYet') || (o.defaultvolume == 0 && o.defaultvolume !== '');

}

exports.dzsvg_check_multisharer = dzsvg_check_multisharer;
exports.get_base_url_arr = get_base_url_arr;
exports.dzsvg_click_open_embed_ultibox = dzsvg_click_open_embed_ultibox;
exports.fullscreen_status = fullscreen_status;
exports.can_history_api = can_history_api;
exports.get_query_arg = get_query_arg;
exports.is_ios = is_ios;
exports.is_android = is_android;
exports.is_safari = is_safari;
exports.is_mobile = is_mobile;
exports.is_touch_device = is_touch_device;
exports.can_translate = can_translate;
exports.add_query_arg = add_query_arg;
exports.multisharer_markup = multisharer_markup;


exports.setup_videogalleryCategories = function (arg) {
  var ccat = jQuery(arg);
  var currCatNr = -1;
  //console.log(ccat);
  ccat.find('.gallery-precon').each(function () {
    var _t = jQuery(this);
    //console.log(_t);
    _t.css({'display': 'none'});
    ccat.find('.the-categories-con').append('<span class="a-category">' + _t.attr('data-category') + '</span>')
  });

  ccat.find('.the-categories-con').find('.a-category').eq(0).addClass('active');
  ccat.find('.the-categories-con').find('.a-category').bind('click', click_category);

  function click_category() {
    var _t = jQuery(this);
    var ind = _t.parent().children('.a-category').index(_t);

    //console.warn('ind - ',ind);
    gotoCategory(ind);
    setTimeout(function () {
      jQuery(window).trigger('resize');
    }, 100);
  }

  //console.info(ccat);

  var i2 = 0;

  ccat.find('.gallery-precon').each(function () {
    var _t = jQuery(this);

    //console.info(_t);

    _t.find('.pagination-number').each(function () {
      var _t2 = jQuery(this);
      //console.log(_t2);

      var auxurl = _t2.attr('href');

      //console.log(auxurl);

      auxurl = helpersDZSVG.add_query_arg(auxurl, ccat.attr('id') + '_cat', NaN);

      //console.log(auxurl);

      auxurl = helpersDZSVG.add_query_arg(auxurl, ccat.attr('id') + '_cat', i2);

      _t2.attr('href', auxurl);
    })

    i2++;
  })

  var tempCat = 0;

  //console.info(window.location.href, ccat.attr('id')+'_cat', helpersDZSVG.get_query_arg(window.location.href, ccat.attr('id')+'_cat'))

  if (helpersDZSVG.get_query_arg(window.location.href, ccat.attr('id') + '_cat')) {
    tempCat = Number(helpersDZSVG.get_query_arg(window.location.href, ccat.attr('id') + '_cat'));
  }


  ccat.get(0).api_goto_category = gotoCategory;

  gotoCategory(tempCat, {
    'called_from': 'init'
  });

  function gotoCategory(arg, pargs) {


    var margs = {
      'called_from': 'default'
    };


    if (pargs) {
      margs = jQuery.extend(margs, pargs);
    }

    //console.error('gotoCategory() -', arg, margs);

    if (currCatNr > -1 && ccat.find('.gallery-precon').eq(currCatNr).find('.videogallery').eq(0).get(0) != undefined && ccat.find('.gallery-precon').eq(currCatNr).find('.videogallery').eq(0).get(0).external_handle_stopCurrVideo != undefined) {


      var ind = 0;
      ccat.find('.gallery-precon').each(function () {


        //console.info(jQuery(this));
        if (ind != arg) {

          jQuery(this).find('.videogallery').eq(0).get(0).external_handle_stopCurrVideo();
        }
        ind++;
      })


    }
    ccat.find('.gallery-precon').removeClass('curr-gallery');
    ccat.find('.the-categories-con').find('.a-category').removeClass('active');
    ccat.find('.the-categories-con').find('.a-category').eq(arg).addClass('active');
    ccat.find('.gallery-precon').addClass('disabled');
    ccat.find('.gallery-precon').eq(arg).css('display', '').removeClass('disabled');

    var _cach = ccat.find('.gallery-precon').eq(arg);
    var _cachg = _cach.find('.videogallery').eq(0);

    //console.info('_cach - ',_cach);
    //console.info('_cachg - ',_cachg);

    if (_cachg.get(0) && _cachg.get(0).init_settings) {

      //console.info('_cachg.get(0).init_settings - ',_cachg.get(0).init_settings.autoplay);

      if (_cachg.get(0).init_settings.autoplay == 'on') {
        setTimeout(function () {

          _cachg.get(0).api_play_currVideo();
        }, 10);

        if (margs.called_from == 'deeplink' || margs.called_from == 'init') {

          setTimeout(function () {

            //_cachg.get(0).api_play_currVideo();
          }, 1000);
          setTimeout(function () {

            _cachg.get(0).api_play_currVideo();
          }, 1500);
        }
      }
    }

    setTimeout(function () {
      ccat.children('.dzsas-second-con').hide();
      ccat.children('.dzsas-second-con').eq(arg).show();


      //console.info(ccat.find('.gallery-precon').eq(arg));

      ccat.find('.gallery-precon').eq(arg).addClass('curr-gallery');


      currCatNr = arg;

      //console.log(ccat.find('.gallery-precon').eq(arg).find('.videogallery').eq(0));
      if (typeof ccat.find('.gallery-precon').eq(arg).find('.videogallery').eq(0).get(0) != 'undefined' && typeof ccat.find('.gallery-precon').eq(arg).find('.videogallery').eq(0).get(0).api_handleResize != 'undefined') {
        ccat.find('.gallery-precon').eq(arg).find('.videogallery').eq(0).get(0).api_handleResize();
        ccat.find('.gallery-precon').eq(arg).find('.videogallery').eq(0).get(0).api_handleResize_currVideo();
      }
      setTimeout(function () {

        jQuery(window).trigger('resize');
      }, 1500);


    }, 50);


  }

}
exports.youtube_sanitize_url_to_id = function (arg) {


  if (arg) {

    if (String(arg).indexOf('youtube.com/embed') > -1) {
      var auxa = String(dataSrc).split('youtube.com/embed/');
      //console.info(auxa);

      if (auxa[1]) {

        return auxa[1];
      }
    }

    if (arg.indexOf('youtube.com') > -1 || arg.indexOf('youtu.be') > -1) {


      if (helpersDZSVG.get_query_arg(arg, 'v')) {
        return helpersDZSVG.get_query_arg(arg, 'v');
      }

      if (arg.indexOf('youtu.be') > -1) {
        var arr = arg.split('/');

        arg = arr[arr.length - 1];
      }
    }
  }


  return arg;
}

exports.htmlEntities = function (str) {
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

exports.registerAuxjQueryExtends = function ($) {


  Math.easeIn = function (t, b, c, d) {

    return -c * (t /= d) * (t - 2) + b;

  };
  Math.easeOut = function (t, b, c, d) {
    t /= d;
    return -c * t * (t - 2) + b;
  };


  $.fn.prependOnce = function (arg, argfind) {
    var _t = $(this) // It's your element


//        console.info(argfind);
    if (typeof (argfind) == 'undefined') {
      var regex = new RegExp('class="(.*?)"');
      var auxarr = regex.exec(arg);


      if (typeof auxarr[1] != 'undefined') {
        argfind = '.' + auxarr[1];
      }
    }


    // we compromise chaining for returning the success
    if (_t.children(argfind).length < 1) {
      _t.prepend(arg);
      return true;
    } else {
      return false;
    }
  };
  $.fn.appendOnce = function (arg, argfind) {
    var _t = $(this) // It's your element


    if (typeof (argfind) == 'undefined') {
      var regex = new RegExp('class="(.*?)"');
      var auxarr = regex.exec(arg);


      if (typeof auxarr[1] != 'undefined') {
        argfind = '.' + auxarr[1];
      }
    }
//        console.info(_t, _t.children(argfind).length, argfind);
    if (_t.children(argfind).length < 1) {
      _t.append(arg);
      return true;
    } else {
      return false;
    }
  };


//    --- mega conflict with mediaelement.js, well workaround by treating untreated flash items

  var d = new Date();
  window.dzsvg_time_started = d.getTime();


  var inter_check_treat = 0;

  clearTimeout(inter_check_treat);
  inter_check_treat = setTimeout(workaround_treatuntretreadItems, 2000);

  function workaround_treatuntretreadItems() {
    jQuery('.js-api-player:not(.treated)').each(function () {
      var _t = jQuery(this);
      var $ytApiPlayer_ = _t.get(0);
//            console.info(_t, __t);

      var playerId = _t.attr('id');

      var aux = playerId.substr(8);
      var aux2 = _t.attr('data-suggestedquality');
      //console.log(aux2);

      if (typeof $ytApiPlayer_.loadVideoById != 'undefined') {
        $ytApiPlayer_.loadVideoById(aux, 0, aux2);
        $ytApiPlayer_.pauseVideo();
      } else {

        inter_check_treat = setTimeout(workaround_treatuntretreadItems, 2000);
      }


    })

  }

  // -- we save the other youtube player ready functions ( maybe conflict with other players )
  if (window.onYouTubePlayerReady && typeof window.onYouTubePlayerReady == 'function' && typeof backup_onYouTubePlayerReady == 'undefined') {
    window.dzsvg_backup_onYouTubePlayerReady = window.onYouTubePlayerReady;
  }
}

exports.dzsvgExtraWindowFunctions = function () {


  window.dzsvg_wp_send_view = function (argcthis, argtitle) {
    // console.info('window.dzsvg_wp_send_view() -5 ', argcthis, argtitle);


    var data = {
      video_title: argtitle
      , video_analytics_id: argcthis.attr('data-player-id')
    };

    if (window.dzsvg_curr_user) {
      data.dzsvg_curr_user = window.dzsvg_curr_user;
    }

    var theajaxurl = 'index.php?action=ajax_dzsvg_submit_view';

    if (window.dzsvg_site_url) {
      theajaxurl = dzsvg_settings.dzsvg_site_url + theajaxurl;
    }


    jQuery.ajax({
      type: "POST",
      url: theajaxurl,
      data: data,
      success: function (response) {
        if (typeof window.console != "undefined") {
          console.log('Ajax - submit view - ' + response);
        }


      },
      error: function (arg) {
        if (typeof window.console != "undefined") {
          console.warn('Got this from the server: ' + arg);
        }
        ;
      }
    });


  }


  window.dzsvg_wp_send_contor_60_secs = function (argcthis, argtitle) {

    var data = {
      video_title: argtitle
      // ,video_analytics_id: argcthis.attr('data-analytics-id')
      , video_analytics_id: argcthis.attr('data-player-id')
      , dzsvg_curr_user: window.dzsvg_curr_user
    };
    var theajaxurl = 'index.php?action=ajax_dzsvg_submit_contor_60_secs';

    if (window.dzsvg_site_url) {

      theajaxurl = dzsvg_settings.dzsvg_site_url + theajaxurl;
    }


    jQuery.ajax({
      type: "POST",
      url: theajaxurl,
      data: data,
      success: function (response) {
        if (typeof window.console != "undefined") {
          console.log('Ajax - submit view - ' + response);
        }


      },
      error: function (arg) {
        if (typeof window.console != "undefined") {
          console.warn('Got this from the server: ' + arg);
        }
        ;
      }
    });
  }


  window.dzsvg_open_social_link = function (arg) {
    var leftPosition, topPosition;
    var w = 500, h = 500;


    // console.info('arg - ',arg);
    arg = arg.replace(/{{replacewithcurrurl}}/g, encodeURIComponent(window.location.href));
    console.warn('arg - ', arg);
    //Allow for borders.
    leftPosition = (window.screen.width / 2) - ((w / 2) + 10);
    //Allow for title and status bars.
    topPosition = (window.screen.height / 2) - ((h / 2) + 50);
    var windowFeatures = "status=no,height=" + h + ",width=" + w + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";
    window.open(arg, "sharer", windowFeatures);
  }


  window.dzsvp_yt_iframe_ready = function () {

    _global_youtubeIframeAPIReady = true;
  }

  window.onYouTubeIframeAPIReady = function () {
    window.dzsvp_yt_iframe_ready();
  }


  window.requestAnimFrame = (function () {
    return window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      function (callback) {
        window.setTimeout(callback, 1000 / 60);
      };
  })();

}


exports.extractOptionsFromPlayer = function ($c) {

  // console.log('$c - ', $c);
  if ($c.data('originalPlayerAttributes')) {
    return $c.data('originalPlayerAttributes');
  }
  var finalOptions = {};


  if (getDataOrAttr($c, 'data-sourcevp')) {
    finalOptions.source = getDataOrAttr($c, 'data-sourcevp');
  }
  if ($c.attr('data-type')) {
    finalOptions.type = $c.attr('data-type');
  }

  return finalOptions;
}


exports.convertPluginOptionsToFinalOptions = function (elThis, defaultOptions, argOptions = null, searchedAttr = 'data-options', searchedDivClass = 'feed-options') {

  var finalOptions = null;
  var tempOptions = {};
  var sw_setFromJson = false;
  var _elThis = jQuery(elThis);

  if (argOptions && typeof argOptions == 'object') {
    tempOptions = argOptions;
  } else {

    if (_elThis.attr(searchedAttr)) {
      try {
        tempOptions = JSON.parse(_elThis.attr(searchedAttr));
        sw_setFromJson = true;
      } catch (err) {
        console.log('json parse error searched attr err - ', err, _elThis.attr(searchedAttr));
      }
    } else {

      if (_elThis.find('.feed-options').length) {
        try {
          tempOptions = JSON.parse(_elThis.find('.feed-options').html());
          sw_setFromJson = true;
        } catch (err) {
          console.log('json parse error feed-options err - ', err, _elThis.find('.feed-options').html());
        }
      }
    }
    if (!sw_setFromJson) {

      // -- *deprecated
      if (typeof argOptions == 'undefined' || !argOptions) {
        if (typeof _elThis.attr(searchedAttr) != 'undefined' && _elThis.attr(searchedAttr) !== '') {
          var aux = _elThis.attr(searchedAttr);
          aux = 'var aux_opts = ' + aux;
          eval(aux);
          tempOptions = Object.assign({}, aux_opts);
        }
      }
    }
  }

  finalOptions = Object.assign(defaultOptions, tempOptions);

  return finalOptions;
}

exports.player_setupQualitySelector = function (selfClass, yt_qualCurr, yt_qualArray) {
  var _qualitySelector = selfClass.cthis.find('.quality-selector');
  if (_qualitySelector.find('.dzsvg-tooltip').length) {

    var aux = _qualitySelector.find('.dzsvg-tooltip').html();
    var aux_opts = '';
    // console.info('yt_qualArray -> ', yt_qualArray);
    for (var i2 in yt_qualArray) {
      aux_opts += '<div class="quality-option';
      if (yt_qualCurr === yt_qualArray[i2]) {
        aux_opts += ' active';
      }
      aux_opts += '" data-val="' + yt_qualArray[i2] + '">' + yt_qualArray[i2] + '</div>';
    }
    aux = aux.replace('{{quality-options}}', aux_opts);
    _qualitySelector.find('.dzsvg-tooltip').html(aux);
  }

}
exports.playerHandleDeprecatedAttrSrc = function (cthis) {


  if (!cthis.attr('data-sourcevp')) {
    if (cthis.attr('data-source')) {
      cthis.attr('data-sourcevp', cthis.attr('data-source'));
    } else {

      if (cthis.attr('data-src')) {
        cthis.attr('data-sourcevp', cthis.attr('data-src'));

      }
    }
  }
}

exports.player_assert_autoplay = function (selfClass) {

  // console.log('is_mobile() - ', is_mobile(), ' o.autoplay - ', o.autoplay);
  // -- autoplay assert

  var o = selfClass.initOptions;
  // console.log('config autoplay - ', o.autoplay);


  if (is_mobile()) {

  }

  // console.log('asserted autoplay - ', selfClass.autoplayVideo);


}
exports.configureAudioPlayerOptionsInitial = function (cthis, o, selfClass) {
  // console.warn('o.first_video_from_gallery - ',o.first_video_from_gallery, (is_safari()));


  if (o.gallery_object != null) {
    if (typeof (o.gallery_object.get(0)) != 'undefined') {
      selfClass.$parentGallery = o.gallery_object;
      // debugger;
      // console.log('get selfClass.$parentGallery')
      setTimeout(function () {
        if (selfClass.$parentGallery.get(0).api_video_ready) {
          selfClass.$parentGallery.get(0).api_video_ready();
        }
      }, ConstantsDzsvg.DELAY_MINUSCULE);
    }
  }


  if (is_mobile() || (o.first_video_from_gallery === 'on' && (is_safari()))) {
    if (is_mobile()) {
      cthis.addClass('is-mobile');
    }
    if (cthis.attr('data-img')) {
    } else {
      cthis.removeClass('hide-on-paused');
    }
  }

  // console.info('autoplay - ',autoplay);


  //console.info(cthis, o.responsive_ratio);

//            console.info(Number(o.playfrom));


  if (o.playfrom === 'default') {
    if (typeof selfClass.cthis.attr('data-playfrom') != 'undefined' && selfClass.cthis.attr('data-playfrom') != '') {
      o.playfrom = selfClass.cthis.attr('data-playfrom');
    }
  }
  if (isNaN(Number(o.playfrom)) == false) {
    o.playfrom = Number(o.playfrom);
  }
  if (isNaN(Number(o.sliderAreaHeight)) == false) {
    o.sliderAreaHeight = Number(o.sliderAreaHeight);
  }


  cthis.data('embed_code', o.embed_code);


  selfClass.videoWidth = cthis.width();
  selfClass.videoHeight = cthis.height();

  // console.info('o.autoplay - ',o.autoplay);

  if (o.autoplay === 'on') {
    selfClass.autoplayVideo = 'on';
  }

  if (!selfClass.dataSrc) {
    console.log('[dzsvg] missing source', selfClass.cthis);
  }

  var mainClass = '';
  if (typeof (cthis.attr('class')) == 'string') {
    mainClass = cthis.attr('class');
  } else {
    mainClass = cthis.get(0).className;
  }

  if (mainClass.indexOf('skin_') == -1) {
    cthis.addClass(o.design_skin);
    mainClass += ' ' + o.design_skin;
  }


  cthis.addClass(o.extra_classes);
  //console.info('scrubbar width - ',cthis, o.design_scrubbarWidth);
  //-setting skin specific vars
  if (mainClass.indexOf('skin_aurora') > -1) {
    o.design_skin = 'skin_aurora';
    selfClass.bufferedWidthOffset = -2;
    selfClass.volumeWidthOffset = -2;
    if (o.design_enableProgScrubBox == 'default') {
      o.design_enableProgScrubBox = 'on';
    }
    if (o.design_scrubbarWidth == 'default') {
      o.design_scrubbarWidth = -113;
    }
  }
  if (mainClass.indexOf('skin_pro') > -1) {
    o.design_skin = 'skin_pro';

    selfClass.volumeWidthOffset = -2;
    if (o.design_enableProgScrubBox == 'default') {
      o.design_enableProgScrubBox = 'off';
    }
    if (o.design_scrubbarWidth == 'default') {
      o.design_scrubbarWidth = 0;
    }
  }
  if (mainClass.indexOf('skin_bigplay') > -1) {
    o.design_skin = 'skin_bigplay';
  }
  if (mainClass.indexOf('skin_nocontrols') > -1) {
    o.design_skin = 'skin_nocontrols';
  }
  if (mainClass.indexOf('skin_bigplay_pro') > -1) {
    o.design_skin = 'skin_bigplay_pro';
  }
  if (mainClass.indexOf('skin_bluescrubtop') > -1) {
    o.design_skin = 'skin_bluescrubtop';

    if (o.design_scrubbarWidth == 'default') {
      o.design_scrubbarWidth = 0;
    }
  }
  if (mainClass.indexOf('skin_avanti') > -1) {
    o.design_skin = 'skin_avanti';

    if (o.design_scrubbarWidth == 'default') {
      o.design_scrubbarWidth = -125;
    }
  }
  if (mainClass.indexOf('skin_noskin') > -1) {
    o.design_skin = 'skin_noskin';
  }


  if (cthis.hasClass('skin_white')) {
    o.design_skin = 'skin_white';
  }
  if (cthis.hasClass('skin_reborn')) {
    o.design_skin = 'skin_reborn';
    if (o.design_scrubbarWidth == 'default') {
      o.design_scrubbarWidth = -312;

    }
  }


//                    console.info(o.design_scrubbarWidth);
  if (o.design_scrubbarWidth == 'default') {
    o.design_scrubbarWidth = -201;
  }

  // console.log('is_mobile - ',is_mobile, this);
  if (is_mobile() || is_ios()) {
    cthis.addClass('disable-volume');

    if (o.design_skin == 'skin_reborn') {
      o.design_scrubbarWidth += 65;
    }
  }


  if (o.gallery_object) {
    if (o.gallery_object.get(0)) {
      cthis.get(0).gallery_object = o.gallery_object.get(0);
    }
  }


  if (o.extra_controls) {
    cthis.append(o.extra_controls);
  }


  if (o.responsive_ratio === 'default' || (selfClass.dataType === 'youtube' && o.responsive_ratio === 'detect')) {

    if (cthis.attr('data-responsive_ratio')) {
      o.responsive_ratio = cthis.attr('data-responsive_ratio');
    }
  }

  if (o.gallery_object !== null) {
    selfClass.isPartOfAnGallery = true;
  }
  if (selfClass.isPartOfAnGallery) {
    selfClass.isGalleryHasOneVideoPlayerMode = o.gallery_object.data('vg_settings') && o.gallery_object.data('vg_settings').mode_normal_video_mode == 'one';
  }


  // -- we cache this for the one
  if (selfClass.isGalleryHasOneVideoPlayerMode) {
    if (o.gallery_target_index === 0 && !(selfClass.cthis.data('originalPlayerAttributes'))) {
      selfClass.cthis.data('originalPlayerAttributes', this.detect_videoTypeAndSourceForElement(selfClass.cthis));
    }
  }

  if (o.action_video_view === 'wpdefault') {
    o.action_video_view = window.dzsvg_wp_send_view;
  }
  if (o.action_video_contor_60secs === 'wpdefault') {
    o.action_video_contor_60secs = window.dzsvg_wp_send_contor_60_secs;
  }


  this.reinitPlayerOptions(selfClass, o);
}


exports.reinitPlayerOptions = function (selfClass, o) {
  // -- we need  selfClass.dataType and selfClass.dataSrc beforeHand


  selfClass.hasCustomSkin = true;
  // -- assess custom skin
  if (selfClass.dataType == 'vimeo' && o.vimeo_is_chromeless !== 'on') {
    selfClass.hasCustomSkin = false;
  }
  if (selfClass.dataType == 'youtube' && o.settings_youtube_usecustomskin !== 'on') {
    selfClass.hasCustomSkin = false;
  }
  if (this.is_ios() && o.settings_ios_usecustomskin !== 'on') {
    selfClass.hasCustomSkin = false;
  }
  // console.log('selfClass.hasCustomSkin- ' , selfClass.hasCustomSkin);


  this.player_assert_autoplay(selfClass);

  if (o.is_ad === 'on') {
    selfClass.isAd = true;
  }

  player_checkIfItShouldStartMuted(selfClass, o);

  if (selfClass.isAd && o.ad_link) {
    selfClass.ad_link = o.ad_link;
  }


  // -- assess custom skin END
}

function player_checkIfItShouldStartMuted(selfClass, o) {
  // console.log('player_checkIfItShouldStartMuted() ', selfClass.initOptions.autoplay, selfClass.initOptions.autoplayWithVideoMuted)

  const isPlayerOrGalleryHadFirstInteraction = () => {
    if (selfClass.isHadFirstInteraction) return true;
    if (!is_mobile() && selfClass.$parentGallery && selfClass.$parentGallery.hasClass('user-had-first-interaction')) {
      return true;
    }
    return false;
  };

  // -- should start muted
  if (selfClass.cthis.hasClass('start-muted')) {
    selfClass.initOptions.autoplayWithVideoMuted = 'always'; // -- warning: override
  }

  // -- detect
  if (selfClass.initOptions.autoplay === 'off') {
    selfClass.shouldStartMuted = false;

  }
  if (selfClass.initOptions.autoplay === 'on') {

    // console.log('isPlayerOrGalleryHadFirstInteraction-  ', isPlayerOrGalleryHadFirstInteraction());
    if (isPlayerOrGalleryHadFirstInteraction()) {
      selfClass.shouldStartMuted = false;
    } else {
      if (is_mobile()) {
        // -- mobile
        selfClass.shouldStartMuted = selfClass.initOptions.autoplay === 'on' && selfClass.initOptions.autoplayWithVideoMuted === 'auto';
      } else {
        // -- desktop
        if (o.autoplayWithVideoMuted === 'auto') {
          selfClass.shouldStartMuted = true;
        }
      }

    }
  }
  // -- should start muted

  if (o.autoplayWithVideoMuted === 'always') {
    selfClass.shouldStartMuted = true;
  }
  // console.log('selfClass.shouldStartMuted - ', selfClass.shouldStartMuted);
}

exports.tagsSetupDom = function (_tagElement) {
  var auxhtml = _tagElement.html();
  var w = 100;
  var h = 100;
  var acomlink = '';
  if (_tagElement.attr('data-width') != undefined) {
    w = _tagElement.attr('data-width');
  }
  if (_tagElement.attr('data-height') != undefined) {
    h = _tagElement.attr('data-height');
  }
  if (_tagElement.attr('data-link') != undefined) {
    acomlink = '<a href="' + _tagElement.attr('data-link') + '"></a>';
  }

  _tagElement.html('');
  _tagElement.css({'left': (_tagElement.attr('data-left') + 'px'), 'top': (_tagElement.attr('data-top') + 'px')});
  //console.log(_tagElement);
  _tagElement.append('<div class="tag-box" style="width:' + w + 'px; height:' + h + 'px;">' + acomlink + '</div>');
  _tagElement.append('<span class="tag-content">' + auxhtml + '</span>');
  _tagElement.removeClass('dzstag-tobe').addClass('dzstag');
  //_tagElement.remove();
}
exports.pauseDzsapPlayers = function () {
  if (window.dzsap_list) {
    for (var i = 0; i < dzsap_list.length; i++) {

      //                    console.info(!is_ie8(), dzsap_list[i].get(0), typeof dzsap_list[i].get(0)!="undefined", typeof dzsap_list[i].get(0).api_pause_media!="undefined")
      if (typeof dzsap_list[i].get(0) != "undefined" && typeof dzsap_list[i].get(0).api_pause_media != "undefined" && dzsap_list[i].get(0) != cthis.get(0)) {

        //console.info('try to pause', dzsap_list[i].get(0),dzsap_list[i].data('type_audio_stop_buffer_on_unfocus'))
        if (dzsap_list[i].data('type_audio_stop_buffer_on_unfocus') && dzsap_list[i].data('type_audio_stop_buffer_on_unfocus') == 'on') {
          dzsap_list[i].get(0).api_destroy_for_rebuffer();
        } else {

          dzsap_list[i].get(0).api_pause_media({
            'audioapi_setlasttime': false
          });
        }
        window.dzsap_player_interrupted_by_dzsvg = dzsap_list[i].get(0);
      }
    }

  }

}
exports.init_navigationOuter = function () {
  jQuery('.videogallery--navigation-outer').each(function () {
    var _t = jQuery(this);


    var xpos = 0;
    _t.find('.videogallery--navigation-outer--bigblock').each(function () {
      var _t = jQuery(this);
      _t.css('left', xpos + '%');
      xpos += 100;
    })

    // console.warn('_t.attr(\'data-vgtarget\') -',_t.attr('data-vgtarget'));


    // -- we will use first gallery if id is auto
    if (_t.attr('data-vgtarget') == '.id_auto') {


      var _cach = jQuery('.videogallery,.videogallery-tobe').eq(0);
      // console.info('jQuery(\'.videogallery\').eq(0) - ',_cach.eq(0));

      var cclass = /id_(.*?) /.exec(_cach.attr('class'));

      if (cclass && cclass[1]) {
        _t.attr('data-vgtarget', '.id_' + cclass[1]);
      }

      if (_cach.get(0) && _cach.get(0).api_set_outerNav) {
        _cach.get(0).api_set_outerNav(_t);
      }
      setTimeout(function () {
        if (_cach.get(0) && _cach.get(0).api_set_outerNav) {
          _cach.get(0).api_set_outerNav(_t);
        }
      }, 1000)
    }
    var _tar = jQuery(_t.attr('data-vgtarget')).eq(0);


    var _clip = _t.find('.videogallery--navigation-outer--clip').eq(0);
    var _clipmover = _t.find('.videogallery--navigation-outer--clipmover').eq(0);

    var currPage = 0;
    var _block_active = _t.find('.videogallery--navigation-outer--bigblock.active').eq(0);
//        console.info(_tar);

    var _navOuterBullets = _t.find('.navigation-outer--bullet');
    var _navOuterBlocks = _t.find('.videogallery--navigation-outer--block');

    setTimeout(function () {
      _t.addClass('active');
      _block_active = _t.find('.videogallery--navigation-outer--bigblock.active').eq(0);
      _clip.height(_block_active.height());
    }, 500)

    _navOuterBlocks.bind('click', function () {
      var _t2 = jQuery(this);
      var ind = _navOuterBlocks.index(_t2);


//            console.info(ind);

      if (_tar.get(0) && _tar.get(0).api_gotoItem) {
        if (_tar.get(0).api_gotoItem(ind)) {
        }


        jQuery('html, body').animate({
          scrollTop: _tar.offset().top
        }, ConstantsDzsvg.ANIMATIONS_DURATION);
      }
    });

    _navOuterBullets.bind('click', function () {
      var _t2 = jQuery(this);
      var ind = _navOuterBullets.index(_t2);

      gotoPage(ind);

    })

    function gotoPage(arg) {
      var auxl = -(Number(arg) * 100) + '%';

      _navOuterBullets.removeClass('active');
      _navOuterBullets.eq(arg).addClass('active');

      _t.find('.videogallery--navigation-outer--bigblock.active').removeClass('active');
      _t.find('.videogallery--navigation-outer--bigblock').eq(arg).addClass('active');


      _clip.height(_t.find('.videogallery--navigation-outer--bigblock').eq(arg).height());

      _clipmover.css('left', auxl);

    }


  })
}
exports.vimeo_do_command = function (selfClass, vimeo_data, vimeo_url) {

  if (vimeo_url) {

    //console.info(vimeo_url);
    if (selfClass._videoElement && selfClass._videoElement.contentWindow && vimeo_url) {

      selfClass._videoElement.contentWindow.postMessage(JSON.stringify(vimeo_data), vimeo_url);
    }
  }
}
exports.dash_setupPlayer = function (selfClass) {

  var dash_player = null
    , dash_context = null
  ;

  // console.warn("Reading from source ", selfClass.dataSrc);


  function setup_dash() {

    dash_context = new Webm.di.WebmContext();
    dash_player = new MediaPlayer(dash_context);
    dash_player.startup();
    dash_player.attachView(video);

    if (selfClass.autoplayVideo == 'on') {
      dash_player.setAutoPlay(true);
    } else {
      dash_player.setAutoPlay(false);
    }
    dash_player.attachSource(selfClass.dataSrc);
  }

  if (!(selfClass && selfClass.dataSrc)) {
    console.log('[dzsvg][error] no selfclass .. no src ?? ');
    return false;
  }

  if (window.Webm) {

    setup_dash();


    //console.info(selfClass._videoElement.naturalWidth);
  } else {


    var baseUrl = '';
    var baseUrl_arr = helpersDZSVG.get_base_url_arr();
    for (var i24 = 0; i24 < baseUrl_arr.length - 1; i24++) {
      baseUrl += baseUrl_arr[i24] + '/';
    }
    //var src = scripts[scripts.length-1].src;


    var url = baseUrl + 'dash.js';
    //console.warn(scripts[i23], baseUrl, url);
    jQuery.ajax({
      url: url,
      dataType: "script",
      success: function (arg) {
        //console.info(arg);

        setup_dash();


      }
    });
  }
}

exports.playlistGotoItemHistoryChangeForLinks = function (ind_ajaxPage, o, cgallery, _currentTargetPlayer) {


  var $ = jQuery;
  // --- history API ajax cool stuff
  if (o.settings_enableHistory == 'on' && can_history_api()) {
    var stateObj = {foo: "bar"};
    history.pushState(stateObj, "Gallery Video", this.getDataOrAttr(_currentTargetPlayer, 'data-sourcevp'));

    $.ajax({
      url: this.getDataOrAttr(_currentTargetPlayer, 'data-sourcevp'),
      success: function (response) {
        if (window.console != undefined) {
          console.info('Got this from the server: ' + response);
        }
        setTimeout(function () {
          //console.log(jQuery(response).find('.history-video-element').eq(0).get(0).innerHTML);

          $('.history-video-element').eq(0).html($(response).find('.history-video-element').eq(0).html());

          $('.toexecute').each(function () {
            var _t = $(this);
            if (_t.hasClass('executed') == false) {
              eval(_t.text());
              _t.addClass('executed');
            }
          });


          if (o.settings_ajax_extraDivs != '') {
            var extradivs = String(o.settings_ajax_extraDivs).split(',');
            for (let i = 0; i < extradivs.length; i++) {
              //console.log(extradivs[i], jQuery(response).find(extradivs[i]));
              $(extradivs[i]).eq(0).html(jQuery(response).find(extradivs[i]).eq(0).html());
            }
          }

          //console.log(jQuery(response)); console.log(jQuery('.toexecute'));
          //jQuery('.history-video-element').eq(0).get(0).innerHTML = jQuery(response).find('.history-video-element').eq(0).get(0).innerHTML;
          //eval(jQuery('.toexecute').text());
        }, 100);
      },
      error: function (xhr, ajaxOptions, thrownError) {
        if (window.console != undefined) {
          console.error('not found ' + ajaxOptions);
        }
        ind_ajaxPage++;
        cgallery.children('.preloader').fadeOut('slow');

      }
    });

  }
}
exports.playlist_initSetupInitial = playlist_initSetupInitial;

function playlist_initSetupInitial(selfClass, o) {

  // console.log('initial playlist options -5 ', o);

  if (!o.autoplayFirstVideo) {

    o.autoplayFirstVideo = o.autoplay;
  }

  if (o.nav_type === 'outer') {
    if (o.forceVideoHeight === '') {
      o.forceVideoHeight = '300';
    }
  }

  if (o.settings_mode === 'slider') {
    o.menu_position = 'none';
    o.nav_type = 'none';
  }

  if (is_mobile() && o.autoplayNext === 'on') {
    if (o.mode_normal_video_mode !== 'one') {
      o.autoplayNext = 'off';
    }
  }

  selfClass.cgallery.data('vg_autoplayNext', o.autoplayNext);
  selfClass.cgallery.data('vg_settings', o);

  if (isNaN(parseInt(o.menuitem_width, 10)) === false && String(o.menuitem_width).indexOf('%') === -1) {
    o.menuitem_width = parseInt(o.menuitem_width, 10);
  } else {
    o.menuitem_width = '';
  }

  if (isNaN(Number(o.menuitem_height)) === false && o.menuitem_height > 0) {

    o.menuitem_height = Number(o.menuitem_height);
  } else {
    o.menuitem_height = '';
  }
  o.settings_go_to_next_after_inactivity = parseInt(o.settings_go_to_next_after_inactivity, 10);
  //o.menuitem_space = ;


  if (o.startItem != 'default') {
    o.startItem = parseInt(o.startItem, 10);
  }

  // console.info('o.startItem - ',o.startItem);

  o.settings_separation_pages_number = parseInt(o.settings_separation_pages_number, 10);
  o.settings_trigger_resize = parseInt(o.settings_trigger_resize, 10);


  selfClass.$feedItemsContainer = selfClass.cgallery;

  if (selfClass.cgallery.children('.items').length) {
    selfClass.$feedItemsContainer = selfClass.cgallery.children('.items');
  }


  var masonry_options_default = {
    columnWidth: 1
    , containerStyle: {position: 'relative'}
    , isFitWidth: false
    , isAnimated: true
  };

  //console.info(o.masonry_options);

  o.masonry_options = Object.assign(masonry_options_default, o.masonry_options);


  if (can_history_api() === false) {
    o.settings_enable_linking = 'off';
  }

  if (selfClass.cgallery.children('.feed-layout-builder--menu-items')) {
    selfClass.navigation_customStructure = selfClass.cgallery.children('.feed-layout-builder--menu-items').eq(0).html();
  }

  if (!selfClass.navigation_customStructure) {
    if (!o.design_skin) {
      o.design_skin = 'skin-default';
    }
  }


  // console.log('o.settings_mode  - ', o.settings_mode);
  if (o.settings_mode == 'rotator3d') {

    o.menu_position = 'none';
    o.nav_type = 'none';
    o.transition_type = 'rotator3d';
  }


  if (typeof o.videoplayersettings == 'string' && window.dzsvg_vpconfigs) {
    if (typeof window.dzsvg_vpconfigs[o.videoplayersettings] === 'object') {
      o.videoplayersettings = {...window.dzsvg_vpconfigs[o.videoplayersettings]};
    }
  }


  if (o.videoplayersettings.design_skin === 'sameasgallery') {
    o.videoplayersettings.design_skin = o.design_skin;
  }


}

exports.playlist_navigation_set_dimensions = function (selfClass, menu_position, menuitem_width, menuitem_height, totalWidth, totalHeight) {

  var cssArgs = {};
  if (menu_position === 'right') {

    if (selfClass.cgallery.hasClass('ultra-responsive')) {

      selfClass._mainNavigation.css({
        'height': '' // height is auto in ultra-responsive
      });
    } else {
      selfClass._mainNavigation.css({
        'width': menuitem_width
        , 'height': totalHeight
      })
    }

  }
  if (menu_position === 'left') {

    //console.log(totalHeight);
    if (selfClass.cgallery.hasClass('ultra-responsive')) {

    } else {
      cssArgs = {
        'width': menuitem_width,
        'height': totalHeight,
        'left': 0
      };
      selfClass._mainNavigation.css(cssArgs);
    }
  }
  if (menu_position == 'bottom') {
    // console.log('menuitem_height -' , menuitem_height);

    cssArgs = {
      'width': totalWidth,
    };
    if (!isNaN(Number(selfClass.initOptions.menuitem_height))) {
      cssArgs.height = menuitem_height
    }
    selfClass._mainNavigation.css(cssArgs)
  }
  if (menu_position == 'top') {
    selfClass._mainNavigation.css({
      'width': totalWidth
      , 'height': ''
    });
  }
}
exports.playlist_navigationGenerateStructure = playlist_navigationGenerateStructure;

/**
 * we need selfClass.navigation_customStructure
 * @param selfClass
 */
function playlist_navigationGenerateStructure(selfClass) {

  var desc = selfClass.navigation_customStructure;
  return desc;

}

exports.playlist_navigationStructureAssignVars = function (selfClass, $currentVideoPlayer, _cachmenuitem) {

  function replaceInNav(argInMenu, argInStructure) {

    _cachmenuitem.find(argInMenu).html($currentVideoPlayer.find(argInStructure).eq(0).html())
  }

  replaceInNav('.layout-builder--item--type-title', '.feed-menu-title');
  replaceInNav('.layout-builder--item--type-menu-description', '.feed-menu-desc');


  // console.log('_cachmenuitem.find(\'.layout-builder--item--type-thumbnail\') - ', _cachmenuitem.find('.layout-builder--item--type-thumbnail'), $currentVideoPlayer.find('.feed-menu-image'));
  _cachmenuitem.find('.layout-builder--item--type-thumbnail').css('background-image', 'url(' + $currentVideoPlayer.find('.feed-menu-image').html() + ')');
}


/**
 *
 * @param selfClass
 * @param pargs
 */
exports.player_getResponsiveRatio = function (selfClass, pargs) {

  var $ = jQuery;
  var o = selfClass.initOptions;

  var margs = {
    'reset_responsive_ratio': false
    , 'called_from': 'default'
  };

  if (pargs) {
    margs = $.extend(margs, pargs);
  }

  if (margs.reset_responsive_ratio) {
    o.responsive_ratio = 'default';
  }


  // console.log('player_getResponsiveRatio() ', margs);
  // console.log('[player_getResponsiveRatio()] o.responsive_ratio - ', o.responsive_ratio);
  if (o.responsive_ratio === 'detect') {

    // console.info('lets calculate responsive ratio', selfClass.dataType);
    if (selfClass.dataType === 'selfHosted' || selfClass.dataType === 'dash') {
      if (selfClass._videoElement && selfClass._videoElement.videoHeight) {

        o.responsive_ratio = selfClass._videoElement.videoHeight / selfClass._videoElement.videoWidth;
      } else {
        o.responsive_ratio = 0.5625;
      }

      //console.info(o.responsive_ratio);
      if (selfClass._videoElement && selfClass._videoElement.addEventListener) {
        selfClass._videoElement.addEventListener('loadedmetadata', function () {
          o.responsive_ratio = selfClass._videoElement.videoHeight / selfClass._videoElement.videoWidth;
//                                console.info(o.responsive_ratio);
          selfClass.handleResize();
        })
      }

      if (selfClass.dataType === 'dash') {
        selfClass.dash_inter_check_sizes = setInterval(function () {
          if (selfClass._videoElement && selfClass._videoElement.videoHeight) {
            if (selfClass._videoElement.videoWidth > 0) {
              o.responsive_ratio = selfClass._videoElement.videoHeight / selfClass._videoElement.videoWidth;
              selfClass.handleResize();
              clearInterval(selfClass.dash_inter_check_sizes);
            }
          }
        }, 1000);
      }

    }
    if (selfClass.dataType === 'audio') {
      if (selfClass.cthis.find('.div-full-image').length) {
        var _cach = selfClass.cthis.find('.div-full-image').eq(0);

        var aux = _cach.css('background-image');

        aux = aux.replace(/"/g, '');
        aux = aux.replace("url(", '');
        aux = aux.replace(")", '');

        var img = new Image();

        img.onload = function () {
          o.responsive_ratio = this.naturalHeight / this.naturalWidth;
          selfClass.handleResize();
        };
        img.src = aux;
      }


    }
    if (selfClass.dataType === 'youtube') {
      o.responsive_ratio = 0.5625;
    }
    if (selfClass.dataType === 'vimeo') {
      o.responsive_ratio = 0.5625;
    }
    if (selfClass.dataType === 'inline') {
      o.responsive_ratio = 0.5625;
    }

  }
  o.responsive_ratio = Number(o.responsive_ratio);

  if (selfClass.cthis.hasClass('vp-con-laptop')) {
    o.responsive_ratio = '';
  }
  // console.log('final o.responsive_ratio - ',o.responsive_ratio);
}


/**
 * mobiles cannot autoplay
 * @param selfClass
 */
exports.player_ad_setupMobileNotice = function (selfClass) {

  // -- TBC - skip ad notice on mobile
  selfClass.cthis.appendOnce('<div class="skipad-con"></div>', '.skipad-con');
  selfClass.$adSkipCon = selfClass.cthis.find('.skipad-con').eq(0);
  selfClass.$adSkipCon.html("Play the ad for the skip ad counter to appear");
  selfClass.$adSkipCon.attr('data-ad-status', 'waiting_for_play');
}
exports.playlist_inDzsTabsHandle = function (selfClass, margs) {
  // -- tabs
  var _con = selfClass.cgallery.parent().parent().parent();
  if (selfClass.initOptions.autoplayFirstVideo === 'on') {
    if (margs.called_from !== 'init_restart_in_tabs') {

      setTimeout(function () {

        margs.called_from = 'init_restart_in_tabs';
        selfClass.init(margs);
      }, 50);
      return false;
    }
    // console.warn('_con -4 ',_con);
    if (_con.hasClass('active') || _con.hasClass('will-be-start-item')) {

    } else {
      selfClass.initOptions.autoplayFirstVideo = 'off';
    }
  }

}
/**
 * return .previewImg
 * @param _t
 * @returns {null|jQuery|undefined|*}
 */
exports.playlist_navigation_getPreviewImg = function (_t) {
  // console.log('playlist_navigation_getPreviewImg() _t - ', _t);

  let stringPreviewImg = '';
  if (_t.attr('data-previewimg')) {
    stringPreviewImg = _t.attr('data-previewimg');
  } else if (_t.attr('data-audioimg')) {


    stringPreviewImg = _t.attr('data-audioimg');
  } else if (_t.attr('data-thumb')) {


    stringPreviewImg = _t.attr('data-thumb');
  }
  return stringPreviewImg;

}
exports.playlist_get_real_responsive_ratio = function (i, selfClass) {
  var $ = jQuery;
  var o = selfClass.initOptions;
  setTimeout(function (targetIndex) {
    var _cach = selfClass._sliderCon.children().eq(targetIndex);
    //console.info(arg, _cach);
    var src = _cach.data('dzsvg-curatedid-from-gallery');

    $.get(o.php_media_data_retriever + "?action=dzsvg_action_get_responsive_ratio&type=" + _cach.data('dzsvg-curatedtype-from-gallery') + "&source=" + src, function (data) {

      //console.info(data);

      try {
        var json = JSON.parse(data);

        var rr = 0.562;

        if (json.height && json.width) {

          rr = json.height / json.width;
        }

        if (rr.toFixed(3) !== '0.563') {
          _cach.attr('data-responsive_ratio', rr.toFixed(3));
        }
        _cach.attr('data-responsive_ratio-not-known-for-sure', 'off');


        if (_cach.get(0) && _cach.get(0).api_get_responsive_ratio) {
          _cach.get(0).api_get_responsive_ratio({
            'reset_responsive_ratio': true
            , 'called_from': 'php_media_data_retriever'
          })

          setTimeout(function () {
            selfClass.handleResize_currVideo();
          }, 100);
        }
      } catch (err) {
        console.info('json parse error - ', data);
      }


      //_cach.attr('data-responsive_ratio')
    });
  }, 100, i)
}
/**
 * set player data
 * @param _cachmenuitem
 */
exports.playlist_navigation_mode_one__set_players_data = function (_cachmenuitem) {

  var attr_arr = ['data-loop', 'data-sourcevp', 'data-source', 'data-videotitle', 'data-type'];

  var maxlen = attr_arr.length;
  var ci = 0;
  for (var i5 in attr_arr) {
    var lab4 = attr_arr[i5];

    var val = '';
    // console.info('_ci.attr(lab) -5 ',_ci.attr(lab),'lab ( ',lab, ' )');

    // -- put this data in here
    val = getDataOrAttr(_cachmenuitem, lab4)
    if (val) {

      var lab_sanitized_for_data = lab4.replace('data-', 'vp_');
      _cachmenuitem.data(lab_sanitized_for_data, val);
    }

    if (ci > maxlen || ci > 10) {
      break;
    }

    ci++;
  }
}

exports.deprecated__playlist_replace_youtube_thumb_in_desc = deprecated__playlist_replace_youtube_thumb_in_desc;

/** deprecated
 */
function deprecated__playlist_replace_youtube_thumb_in_desc(desc, _currentVp) {
  var self = this;
  if (desc.indexOf('{ytthumb}') > -1 && _currentVp.data('dzsvg-curatedid-from-gallery')) {
    desc = desc.split("{ytthumb}").join('<div style="background-image:url(//img.youtube.com/vi/' + _currentVp.data('dzsvg-curatedid-from-gallery') + '/0.jpg)" class="imgblock divimage"></div>');
  }
  if (desc.indexOf('{ytthumbimg}') > -1 && _currentVp.data('dzsvg-curatedid-from-gallery')) {
    desc = desc.split("{ytthumbimg}").join('//img.youtube.com/vi/' + self.getDataOrAttr(_currentVp, 'data-sourcevp') + '/0.jpg');
  }

  return desc;
}

exports.deprecated__playlist_navigationGenerateStructure = deprecated__playlist_navigationGenerateStructure;

/** deprecated
 */
function deprecated__playlist_navigationGenerateStructure(menu_description_format, _c) {
  var aux = menu_description_format;


  aux = aux.replace('{{number}}', '<div class="menu-number"><span class="the-number">' + _c.find('.feed-menu-number').html() + '</span></div>');
  aux = aux.replace('{{menuimage}}', '<div class="divimage imgblock" style="background-image: url(' + _c.find('.feed-menu-image').html() + ')"></div>');
  aux = aux.replace('{{menutitle}}', '<div class="menu-title" style="">' + _c.find('.feed-menu-title').html() + '</div>');
  aux = aux.replace('{{menudesc}}', '<div class="menu-desc" style="">' + _c.find('.feed-menu-desc').html() + '</div>');
  aux = aux.replace('{{menutime}}', '<div class="menu-time" style="">' + _c.find('.feed-menu-time').html() + '</div>');
  return aux;
}

exports.playlist_setupModeWall = playlist_setupModeWall;

function playlist_setupModeWall(selfClass, o) {
  var $ = jQuery;
  var self = this;
  selfClass._sliderCon.children().each(function () {
    // -- each item
    var _t = $(this);


    if (_t.find('.videoDescription').length == 0) {
      if (_t.find('.menuDescription').length > 0) {
        _t.append('<div class="videoDescription">' + _t.find('.menuDescription').html() + '</div>')
      }
    }


    _t.addClass('vgwall-item').addClass('clearfix dzs-layout-item ultibox-item-delegated');
    _t.css({});
    //console.log(totalWidth, totalHeight);
    _t.attr('data-bigwidth', o.modewall_bigwidth);
    _t.attr('data-bigheight', o.modewall_bigheight);
    _t.attr('data-biggallery', 'vgwall');

    if (_t.attr('data-previewimg')) {

      _t.attr('data-thumb-for-gallery', _t.attr('data-previewimg'));
    } else {

    }

    if (_t.attr('data-videoTitle') != undefined && _t.attr('data-videoTitle') != '' && !_t.find('.videoTitle').length) {
      _t.prepend('<div class="videoTitle">' + _t.attr('data-videoTitle') + '</div>');
    }
    if (_t.attr('data-previewimg') != undefined) {
      var aux2 = _t.attr('data-previewimg');

      if (aux2 !== undefined && aux2.indexOf('{ytthumbimg}') > -1) {
        aux2 = aux2.split("{ytthumbimg}").join('//img.youtube.com/vi/' + self.getDataOrAttr(_t, 'data-sourcevp') + '/0.jpg');
      }

      if (!_t.find('.previewImg').length) {

        _t.prepend('<img class="previewImg" style="" src="' + aux2 + '"/>', '.previewImg');
      }

    }


    if ($.fn.zoomBox) {
      _t.zoomBox();
    }
  });

}

exports.playlistGotoItemHistoryChangeForNonLinks = function (margs, o, cid, arg, deeplinkGotoItemQueryParam = 'the-video') {

  var $ = jQuery;

  var deeplink_str = String(deeplinkGotoItemQueryParam).replace('{{galleryid}}', cid);
  if (margs.ignore_linking == false && margs.called_from != 'init') {
    var stateObj = {foo: "bar"};
    // debugger;
    if ($('.videogallery').length == 1) {
      history.pushState(stateObj, null, this.add_query_arg(window.location.href, deeplink_str, (Number(arg) + 1)));
    } else {
      history.pushState(stateObj, null, this.add_query_arg(window.location.href, deeplink_str + '-' + cid, (Number(arg) + 1)));
    }
  }
}
exports.assertVideoFromGalleryAutoplayStatus = function (currNr, o, cgallery) {
  var shouldVideoAutoplay = false;
  // console.log('gallery autoplay - ', o.autoplayFirstVideo, 'currNr - ', currNr);
  if (currNr === -1) {
    if (o.autoplayFirstVideo === 'on') {
      // console.log(!(cgallery.parent().parent().parent().hasClass('categories-videogallery')));
      if ((cgallery.parent().parent().parent().hasClass('categories-videogallery')) || !!(cgallery.parent().parent().parent().hasClass('categories-videogallery') && !cgallery.parent().parent().hasClass('gallery-precon')) || !!(cgallery.parent().parent().parent().hasClass('categories-videogallery') && cgallery.parent().parent().hasClass('gallery-precon') && cgallery.parent().parent().hasClass('curr-gallery'))) {
        shouldVideoAutoplay = false;
      } else {
        shouldVideoAutoplay = true;
      }
    }

  }
  // console.log('shouldVideoAutoplay-  ', shouldVideoAutoplay);

  //-- if it's not the first video
  if (currNr > -1) {
    if (o.autoplayNext == 'on') {
      shouldVideoAutoplay = true;
      // -- todo: sideeffect - maybe move
      o.videoplayersettings['cueVideo'] = 'on';
    }
  }


  return shouldVideoAutoplay;
}
/**
 * setup video player here .. setup_video
 * @param selfClass
 * @param pargsForVideoSetup
 * @returns {boolean}
 */
exports.generatePlayerMarkupAndSource = function (selfClass, pargsForVideoSetup) {
  var argsForVideoSetup = {
    'preload': 'auto',
    'called_from': 'default',
    'is_dash': false,
    'useCrossOrigin': false,
    'usePlayInline': true,
    'useAudioDimensions': true,
    isGoingToChangeMedia: false,
    is360: false,
    Dzsvg360: null, // -- add the 360 class here if need be

  };

  if (pargsForVideoSetup) {
    argsForVideoSetup = Object.assign(argsForVideoSetup, pargsForVideoSetup);
  }


  var o = selfClass.initOptions;


  // console.log('this - ', this);

  var struct_video_element = '';

  var usePoster = false;
  var posterSourceStr = '';
  var str_crossorigin = ' crossorigin="anonymous"';


  if (selfClass.cthis.attr('data-img')) {
    usePoster = true;
    posterSourceStr = ' poster="' + selfClass.cthis.attr('data-img') + '"';
  }

  var shouldAutoplay = false;


  if (selfClass.autoplayVideo == 'on' && o.settings_mode != 'videowall') {
    shouldAutoplay = true;
  }

  // -- local video
  // -- if we have user action on page it's enough for autoplay with sound
  if (o.old_curr_nr > -1) {
    if (o.autoplayWithVideoMuted == 'on') {
      if (1) {
        if (o.autoplay == 'on') {
          o.autoplayWithVideoMuted = 'off';
        }
      }
    }
  }


  if (argsForVideoSetup.isGoingToChangeMedia) {
    if (selfClass._vpInner) {

      selfClass._vpInner.find('.fullscreen-video-element').remove();
      selfClass._vpInner.find('.video-element').remove();
    }
  }


  if (selfClass.dataType == 'selfHosted') {

    if (is_safari()) {
      if (argsForVideoSetup.preload == 'metadata') {
        argsForVideoSetup.preload = 'auto';
      }
    }


    if (o.is_ad == 'on' && is_mobile()) {
      argsForVideoSetup.preload = 'metadata';
    }


    if (is_ios() && o.settings_ios_usecustomskin == 'off') {
      // console.warn("WE ENTER HERE is_ios no custom skin");
      argsForVideoSetup.preload = 'auto';
    }

    struct_video_element = '<video class="the-video video-element" preload="' + argsForVideoSetup.preload + '" ';

    if (selfClass.shouldStartMuted) {
      // console.info('MUTE IT', cthis);
      struct_video_element += ' muted';

    }

    if (o.touch_play_inline == 'on' || argsForVideoSetup.usePlayInline) {
      struct_video_element += ' webkit-playsinline playsinline';
    }

    // console.log('selfClass.hasCustomSkin - ', selfClass.hasCustomSkin);
    if (!selfClass.hasCustomSkin) {
      struct_video_element += ' controls="true"';
    }

    if (argsForVideoSetup.useCrossOrigin) {
      struct_video_element += str_crossorigin;
    }

    if (selfClass.videoWidth != 0) {
      struct_video_element += ' width="100%"';//struct_video_element += ' width="' + videoWidth + '"';
      struct_video_element += ' height="100%"';//struct_video_element += ' height="' + videoHeight + '"';
    }
    struct_video_element += '></video>';
    // console.log('struct_video_element - ', struct_video_element);

  }
  if (selfClass.dataType == 'audio') {

    struct_video_element = '<audio class="the-video video-element" preload="' + argsForVideoSetup.preload + '" ';
    if (argsForVideoSetup.useAudioDimensions) {

      struct_video_element += ' width="100%"';
      struct_video_element += ' height="100%"';
    }
    struct_video_element += '>';

    if (selfClass.dataSrc) {
      struct_video_element += '<source src="' + selfClass.dataSrc + '" type="audio/mp3"/>'
    }
    struct_video_element += '</audio>';
  }


  if (selfClass.dataType == 'youtube') {

    var youtubeAPIArgs = {};

    selfClass._vpInner.children('.cmedia-con').remove();


    struct_video_element = '<span class="cmedia-con youtube-player-con"><span class="video-element" id="the-media-' + selfClass.currentPlayerId + '"></span></span>';


    if (o.cueVideo == 'off') {
      // o.autoplay='off';
      selfClass.autoplayVideo = 'off';
    }
    //console.info(o.settings_suggestedQuality);


    var playfrom = '';


    if (o.playfrom !== 'default') {

//                    console.info(the_player_id, o.playfrom);

      // -- setup last position youtube
      if (o.playfrom === 'last' && selfClass.id_player !== '') {
        if (typeof Storage != 'undefined') {
          if (typeof localStorage['dzsvp_' + selfClass.id_player + '_lastpos'] != 'undefined') {
            playfrom = (Number(localStorage['dzsvp_' + selfClass.id_player + '_lastpos']))
            // console.error("GOT HERE");
          }
        }
      }

      if (isNaN(Number(o.playfrom)) === false) {
        playfrom = Number(o.playfrom);
      }
    }


    // -- custom controls
    // -- youtube no controls


    var vol = '';

    var param_autoplay = 0;
    //console.log(o);
    if (shouldAutoplay) {
      param_autoplay = 1
    }

    var playerVars = {
      'autoplay': param_autoplay,
      controls: 0,
      'showinfo': 0,
      'playsinline': 1,
      rel: 0,
      autohide: 1,
      start: playfrom,
      wmode: 'transparent',
      iv_load_policy: 3,
      modestbranding: 1,
      enablejsapi: 1,
      disablekb: 1
    };

    // -- youtube

    // console.log('selfClass.shouldStartMuted - ', selfClass.shouldStartMuted);
    if (selfClass.shouldStartMuted) {
      playerVars.mute = 1;
    }

    // console.info('playervars 2 3- ', playerVars);

    youtubeAPIArgs = {
      height: '100%',
      width: '100%',
      // origin: 'http://devsite',
      playerVars: playerVars,//, 'playsinline' : 0, enablejsapi : 1
      videoId: selfClass.dataSrc,
      suggestedQuality: o.settings_suggestedQuality,
      events: {
        'onReady': youtube_onPlayerReady
        , 'onStateChange': youtube_onPlayerStateChange
        , 'onPlaybackQualityChange': onPlayerPlaybackQualityChange
      }
    };


    if (argsForVideoSetup.youtube_useDefaultSkin) {
      // -- init ready controls, not custom skin ( default skin )
      selfClass._vpInner.children(':not(.cover-image)').remove();
      youtubeAPIArgs.playerVars.controls = 1;
    }
  }


  /**
   * vimeo
   */
  if (selfClass.dataType == 'vimeo') {

    //_c.children().remove();
    var src = selfClass.dataSrc;
    var str_autoplay = '';

    if (shouldAutoplay) {
      str_autoplay = '&autoplay=1';
      selfClass.cthis.find('.cover-image').fadeOut('fast');
    }


    if (selfClass._vpInner && o.vimeo_is_chromeless != 'on') {
      selfClass._vpInner.children('.controls').remove();
    }
    //console.info(autoplay, o.autoplay);

    //&title=0&byline=0&portrait=0&badge=0

    // console.log("LOADED VIMEO VIA normal IFRAME");

    // -- <div class="fullscreen-video-element"> todo : we do not need for now

    var str_allowFullscreen = 'webkitAllowFullScreen mozallowfullscreen allowFullScreen';
    // str_allowFullscreen = ' ';
    // -- ;fullscreen
    var str_controls_disable_param = '';

    if (selfClass.hasCustomSkin) {
      str_controls_disable_param = '&controls=0';
    }

    var str_source = 'https:' + '//player.vimeo.com/video/' + src + '?api=1&color=' + o.vimeo_color + '&title=' + o.vimeo_title + str_controls_disable_param + '&byline=' + o.vimeo_byline + '&portrait=' + o.vimeo_portrait + '&badge=' + o.vimeo_badge + '&player_id=vimeoplayer' + src + str_autoplay;

    // console.log('[vimeo][construct] str_autoplay - ', str_autoplay);
    struct_video_element = '<div class="fullscreen-video-element"><iframe allow="autoplay;fullscreen" class="vimeo-iframe video-element from-simple" scrolling="no" src="' + str_source + '" width="100%" height="100%" frameborder="0" ' + str_allowFullscreen + ' style=""></iframe></div>';


  }

  selfClass._fullscreenVideoElement = null;

  selfClass._vpInner.prepend('<div class="dzsvg-video-container">' + struct_video_element + '</div>');


  if (selfClass.dataType == 'vimeo') {
    selfClass._videoElement = selfClass._vpInner.find('.vimeo-iframe').get(0);
    selfClass._fullscreenVideoElement = selfClass._vpInner.find('.fullscreen-video-element').get(0);
  }
  if (selfClass.dataType == 'youtube') {
    // console.log('youtubeAPIArgs - ', youtubeAPIArgs);
    selfClass._videoElement = new YT.Player('the-media-' + selfClass.currentPlayerId, youtubeAPIArgs);
  }
  if (selfClass.dataType == 'selfHosted' || selfClass.dataType == 'audio' || selfClass.dataType == 'dash') {
    selfClass._videoElement = selfClass.cthis.find('.video-element').get(0);
  }

  if (!selfClass._fullscreenVideoElement) {
    selfClass._fullscreenVideoElement = selfClass._videoElement;
  }

  if (argsForVideoSetup.is_dash == true) {
    return false;
  }


  if (selfClass.dataType == 'audio') {

    // return false;
    if (selfClass.cthis.attr('data-sourceogg') != undefined) {
      jQuery(selfClass._videoElement).eq(0).append('<source src="' + selfClass.cthis.attr('data-sourceogg') + '" type="audio/ogg"/>');
    }
    if (selfClass.cthis.attr('data-sourcewav') != undefined) {
      jQuery(selfClass._videoElement).eq(0).append('<source src="' + selfClass.cthis.attr('data-sourcewav') + '" type="audio/wav"/>');
    }
  }
  if (selfClass.dataType == 'vimeo') {


    var self2 = this;
    // console.info('_controlsDiv - ',_controlsDiv);

    // console.log('[dzsvg] [vimeo] fullscreen_status() - ',fullscreen_status());

    selfClass._videoElement.addEventListener("webkitfullscreenchange", function (e) {
      if (fullscreen_status() == -1) {
        jQuery(e.target).parent().parent().removeClass('is_fullscreen is-fullscreen');
      }
      ;
    }, false);
    selfClass._videoElement.addEventListener("fullscreenchange", function (e) {
      if (fullscreen_status() == -1) {
        jQuery(e.target).parent().parent().removeClass('is_fullscreen is-fullscreen');
      }
      ;
    }, false);


    if (window.dzsvg_fullscreen_counter) {
      clearInterval(window.dzsvg_fullscreen_counter);
    }

    window.dzsvg_fullscreen_counter = setInterval(function () {


      // -- leave fullscreen event will not trigger in iframe so we need workaround
      // console.info('fullscreen_status() - ',fullscreen_status());
      if (fullscreen_status() !== 1) {
        // -- not fullscreen
      }

      if (fullscreen_status() === 1) {
        // console.log('fullscreen element - ', window.fullscreenElement);
        if (jQuery('.is_fullscreen').length == 0) {
          jQuery('.vplayer.currItem').addClass('is_fullscreen');
        }
        // console.info('curr fullscreen - ',$('.is_fullscreen'),window.dzsvg_fullscreen_curr_video,$('.is_fullscreen').get(0));


        if (window.dzsvg_fullscreen_curr_video && window.dzsvg_fullscreen_curr_video != jQuery('.is_fullscreen').get(0)) {
          console.log(" FOUND DIFFERENCE");
          // $('.is_fullscreen').get(0).requestFullScreen();


          var elem = jQuery('.is_fullscreen').get(0);

          if (jQuery(elem).hasClass('type-vimeo')) {

            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
              document.webkitExitFullscreen();
            }

          }

        }

        window.dzsvg_fullscreen_curr_video = jQuery('.is_fullscreen').get(0);
      }
    }, 1000);


    if (selfClass.dataType == 'vimeo') {


      function vimeo_addListeners() {
        if (window.Vimeo) {
          if (window._global_vimeoIframeAPILoading_inter) {

            clearInterval(window._global_vimeoIframeAPILoading_inter);
          }
          _global_vimeoIframeAPIReady = true;


          if (selfClass._videoElement) {
            // console.info(_cmedia);

            // -- vimeo events

            var player = new Vimeo.Player(selfClass._videoElement);


            // console.log('player - ', player);
            player.on('play', function () {
              // console.log('[dzsvg][vimeo] play -2')
              selfClass.playMovie_visual()
            });

            player.on('pause', function () {
              selfClass.pauseMovie_visual();
            });


            // console.info('[log] add fullscreen change event');
            selfClass._videoElement.addEventListener('fullscreenchange', selfClass.fullscreenHandleChange, false);
            selfClass._videoElement.addEventListener('webkitfullscreenchange', selfClass.fullscreenHandleChange, false);
          }

        }

      }


      if (window.Vimeo) {
        vimeo_addListeners()
      } else {

        this.load_outside_script(ConstantsDzsvg.VIMEO_IFRAME_API);

        // console.info("ADDED");


        _global_vimeoIframeAPILoading = true;
        window._global_vimeoIframeAPILoading_inter = setInterval(function () {
          vimeo_addListeners();
          // console.info(_global_vimeoIframeAPIReady);
        }, 500);
      }
    }

  }
  if (selfClass.dataType == 'selfHosted') {

    if ((selfClass.dataSrc) && argsForVideoSetup.is_dash == false) {
      if (selfClass.dataSrc && (selfClass.dataSrc.indexOf('.ogg') > -1 || selfClass.dataSrc.indexOf('.ogv') > -1)) {
        selfClass.cthis.attr('data-sourceogg', selfClass.dataSrc);
      }
    }


    if ((selfClass.dataSrc) && argsForVideoSetup.is_dash == false) {
      selfClass.cthis.find('.the-video').eq(0).append('<source src="' + selfClass.dataSrc + '"/>');
    }


    if (selfClass.cthis.attr('data-sourceogg') != undefined) {
      selfClass.cthis.find('.the-video').eq(0).append('<source src="' + selfClass.cthis.attr('data-sourceogg') + '" type="video/ogg"/>');
    }
    if (selfClass.cthis.attr('data-sourcewebm') != undefined) {
      selfClass.cthis.find('.the-video').eq(0).append('<source src="' + selfClass.cthis.attr('data-sourcewebm') + '" type="video/webm"/>');
    }
  }


//                        console.info(o, cthis.attr('data-sourceflash'));


  if (argsForVideoSetup.is360) {
    argsForVideoSetup.Dzsvg360.initPlayer(selfClass);
  }


  function youtube_onPlayerReady(e) {

    if (selfClass._videoElement && selfClass._videoElement.getPlaybackQuality) {
      // console.info('getPlaybackQuality - ', selfClass._videoElement.getPlaybackQuality(), ' | state - ','player ready', ' | quality levels - ',selfClass._videoElement.getAvailableQualityLevels() );


      selfClass._videoElement.setPlaybackQuality(o.settings_suggestedQuality);
    }

    // console.info('yt player ready -8 ', 'o.autoplayWithVideoMuted - ', o.autoplayWithVideoMuted);

    if (selfClass.shouldStartMuted) {
      selfClass.volume_mute();
      selfClass.is_muted_for_autoplay = true;
    }


    // console.warn('o.playfrom - ',o.playfrom);
    // console.warn('autoplay - ',selfClass.autoplayVideo);
    if (o.playfrom == 'last') {
      // TODO: dunno why we need this

      if (selfClass.autoplayVideo == 'off') {

        setTimeout(function () {

          selfClass.pauseMovie({
            'called_from': 'playfrom last'
          });
        }, 1000)
      }
    }


    return false;
    //console.info(selfClass._videoElement.getOptions('cc'));
    selfClass._videoElement.unloadModule('cc'); // For AS3.
    selfClass._videoElement.unloadModule('captions'); // For HTML5.
    selfClass._videoElement.unloadModule("captions");  //Works for AS3 ignored by html5
    selfClass._videoElement.setOption("captions", "track", {"languageCode": "en"});


  }


  function youtube_onPlayerStateChange(e) {

    /*
               -1 – unstarted
               0 – ended
               1 – playing
               2 – paused
               3 – buffering
               5 – video cued
               */

    // console.log('%c youtube_onPlayerStateChange', ConstantsDzsvg.DEBUG_STYLING, 'e - ',e);

    // console.log('e.data - ', e.data);
    if (e.data === 1) { // -- playing
      // -play
      //console.log(paused);
      //if(paused){ playMovie(); }


      // console.info("PLAYED..");


      if (selfClass.queue_goto_perc) {
        selfClass.seek_to_perc(selfClass.queue_goto_perc);
        selfClass.queue_goto_perc = '';
      }


      if (selfClass.ad_status == 'waiting_for_play') {
        selfClass.setup_skipad();
      }

      selfClass.check_if_ad_must_be_played();
      selfClass.check_if_hd_available();

      if (selfClass.youtube_queue_change_quality) {

        selfClass._videoElement.setPlaybackQuality(o.settings_suggestedQuality);
        selfClass.youtube_queue_change_quality = '';
      }

      selfClass.playMovie_visual();
      selfClass.paused = false;
      selfClass.wasPlaying = true;

      selfClass.initial_played = true;


      if (is_mobile()) {
        selfClass.cthis.find('.controls').eq(0).css('pointer-events', 'auto');

      }

    }
    if (e.data == 2) {
      // pause

      if (selfClass.suspendStateForLoop == false) {

        selfClass.pauseMovie({
          'called_from': 'state_2_for_youtube'
        });
      }
      selfClass.paused = true;
      selfClass.wasPlaying = false;
    }

    if (selfClass._videoElement && selfClass._videoElement.getPlaybackQuality) {
      // console.info('getPlaybackQuality - ', selfClass._videoElement.getPlaybackQuality(), ' | state - ',e.data, ' | quality levels - ',selfClass._videoElement.getAvailableQualityLevels() );
    }


    if (e.data == 3) {
      // -- on player play, set the volume again
      selfClass.volumeClass.volume_setInitial();

    }
    if (e.data == 5) {


    }
    if (e.data == 0) {

      // -- handlevideo end
      selfClass.handleVideoEnd();
    }
  }


  function onPlayerPlaybackQualityChange(e) {

    // console.info('onPlayerPlaybackQualityChange', cthis, e.data, e);

  }
}

exports.navigation_detectClassesForPosition = function (menu_position, _mainNavigation, cgallery) {


  const classMenuMovement = (menu_position == 'right' || menu_position == 'left') ? 'menu-moves-vertically' : 'menu-moves-horizontally';
  const classesClearMenuLocations = 'menu-top menu-bottom menu-right menu-left';
  const classesNewMenuLocation = 'menu-' + menu_position + ' ' + classMenuMovement;

  _mainNavigation.removeClass(classesClearMenuLocations);
  _mainNavigation.addClass(classesNewMenuLocation);

  cgallery.removeClass(classesClearMenuLocations);
  cgallery.addClass(classesNewMenuLocation);
}

exports.navigation_initScroller = function (_navMain) {

  var $ = jQuery;
  if ($ && $.fn && $.fn.scroller) {
    _navMain.scroller({
      'enable_easing': 'on'
    });
  }
}
exports.playlist_convertMenuThumbs = function (cgallery, o) {

  var $ = jQuery;
  var self = this;
  cgallery.children().each(function () {
    var _t = $(this);

    if (_t.attr('data-type') == 'youtube' && _t.attr('data-thumb') == undefined) {
      _t.attr('data-thumb', '//img.youtube.com/vi/' + self.sanitize_to_youtube_id(self.getDataOrAttr(_t, 'data-sourcevp')) + '/0.jpg');
    }

    if (_t.attr('data-previewimg') == undefined) {
      if (_t.attr('data-thumb') != undefined) {
        _t.attr('data-previewimg', _t.attr('data-thumb'));
      }

      if (_t.attr('data-img') != undefined) {
        _t.attr('data-previewimg', _t.attr('data-img'));
      }
    }
    if (o.settings_mode == 'wall') {

      if (_t.find('.videoDescription').length == 0) {
        if (_t.find('.menuDescription').length > 0) {
          _t.append('<div class="videoDescription">' + _t.find('.menuDescription').html() + '</div>')
        }
      }
    }
  })
}

/**
 * draw fullscreen bars
 * @param selfClass
 * @param _controls_fs_canvas
 * @param argColor
 */
exports.player_controls_drawFullscreenBarsOnCanvas = function (selfClass, _controls_fs_canvas, argColor) {


  if (selfClass.initOptions.design_skin != 'skin_pro') {
    return;
  }
  var ctx = _controls_fs_canvas.getContext("2d");
  var ctx_w = _controls_fs_canvas.width;
  var ctx_pw = ctx_w / 100;
  var ctx_ph = ctx_w / 100;

  ctx.fillStyle = argColor;
  var borderw = 30;
  ctx.fillRect(25 * ctx_pw, 25 * ctx_ph, 50 * ctx_pw, 50 * ctx_ph);
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(0, borderw * ctx_ph);
  ctx.lineTo(borderw * ctx_pw, 0);
  ctx.fill();
  ctx.moveTo(0, 100 * ctx_ph);
  ctx.lineTo(0, (100 - borderw) * ctx_ph);
  ctx.lineTo(borderw * ctx_pw, 100 * ctx_ph);
  ctx.fill();
  ctx.moveTo((100) * ctx_pw, (100) * ctx_ph);
  ctx.lineTo((100 - borderw) * ctx_pw, (100) * ctx_ph);
  ctx.lineTo((100) * ctx_pw, (100 - borderw) * ctx_ph);
  ctx.fill();
  ctx.moveTo((100) * ctx_pw, (0) * ctx_ph);
  ctx.lineTo((100 - borderw) * ctx_pw, (0) * ctx_ph);
  ctx.lineTo((100) * ctx_pw, (borderw) * ctx_ph);
  ctx.fill();

}
exports.exitFullscreen = function () {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }

  return null;
}
exports.requestFullscreen = function (elem) {
  // console.log('request fullscreen -- ', elem);
  if (elem) {

    if (elem.requestFullScreen) {
      return elem.requestFullScreen();
    } else if (elem.webkitRequestFullScreen) {
      return elem.webkitRequestFullScreen()
    } else if (elem.mozRequestFullScreen) {
      return elem.mozRequestFullScreen()
    }
  }

  return null;
}

exports.load_outside_script = function (arg) {

  // -- vimeo api
  var head = document.getElementsByTagName('head')[0];
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = arg;
  head.appendChild(script);
}